module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product', {
    attrs: {
      "title": "Fragtfirma"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "30px",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px"
    },
    attrs: {
      "src": "https://placehold.it/500x250"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px"
    },
    attrs: {
      "src": "https://placehold.it/500x250"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "20px"
    }
  }, [_vm._v("\n            Fragt og Vognmandsfirma P. Pedersen & Søn Ærø\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø bliver du mødt af en erfaren og fleksibel chauffør. Vores kerneværdier som vi arbejder efter er at være fleksible, effektive og professionelle og altid i tæt dialog med kunderne.\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('contact-cta')], 1), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "16px"
    }
  }, [_vm._v("\n            Fragtfirma\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Alle transportopgaver udføres professionelt, og vi sikre at dine varer kommer sikkert fra A til B. Vi står for et tæt samarbejde med kunderne, og vi lægger stor vægt på transportydelser af højeste kvalitet, punktlighed og til lave omkostninger. I tilfælde af evt. afvigelser vil du altid blive hurtigt informeret.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Fragt og Vognmandsfirma P. Pedersen & Søn Ærø tilbyder transport, kurer- og varekørsel.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Ønsker du et erfarent fragtfirma med sikkerheden i orden er Fragt og Vognmandsfirma P. Pedersen & Søn Ærø det helt rigtige valg.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('h4', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                    Kurerkørsel af forskellige slags\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Kurerkørsel er en transportmulighed for de af vores kunder som skal have transporteret noget her og nu til en specifik adresse. \n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har stor erfaring med transport, kurer- og varekørsel af hasteleveringer til hele landet. \n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Vi afdækker gennem en indledende samtale hvilken opgave og hvilken vare I måtte have behov for at få fragtet. Det vigtigste for os er, at alle vores kunder bliver tilfredse med det arbejde vi udfører. Vi er i tæt dialog med vores kunder, hvor vi forventningsafstemmer og snakker om dine individuelle behov.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Samtalen vil bl.a. indeholde:\n                    "), _c('ul', [_c('li', [_vm._v("Er det en hastesag?")]), _vm._v(" "), _c('li', [_vm._v("Hvad skal leveres?")]), _vm._v(" "), _c('li', [_vm._v("Hvor lang er ruten?")])])]), _vm._v(" "), _c('p', [_vm._v("\n                    Vi ønsker at afdække disse behov bedst muligt med vores fleksible og professionelle løsninger. Vi er af den overbevisning, at du som kunde ikke skal betale for mere end højst nødvendigt, og fordi vi ønsker at være konkurrencedygtige. \n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h4', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                        Hvad er kurerkørsel?\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Kurerkørsel betyder flere former for transport som kan være i en lille varebil. Forsendelserne kan være alt fra breve og dokumenter til små – og store pakker, ligesom kurerkørsel kan være her og nu opgaver med ekspres levering til/fra kunder.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø kan også tilbyde en fast kurer aftale.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Vi er aldrig længere end et opkald væk. Har du en kurerkørsel du skal have løst så; \n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Kontakt os på telefon 40 43 60 78 eller på e-mail karsten@p-pedersen.dk for at drøfte dine behov for vognmandskørsel, helt uforpligtende. Vi giver dig altid et godt tilbud på fragt.\n                    ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17023719"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/freightCompany.vue
// module id = 253
// module chunks = 1